import * as React from 'react';

import {Rating as RatingShell} from '../../rating/rating';

type Props = {
    value?: number;
};

export function Rating(props: Props) {
    if (!props.value) {
        return null;
    }

    return <RatingShell score={props.value} title='User engagement' />;
}
